<template>
    <div class="container-voucher-generator" ref="parent-container" :style="globalStyles">
        <transition name="step">
            <div class="step-1" v-if="currentStep === 1" ref="step1">
                <div class="logo-app">
                    <div class="logo">
                        <img src="https://content.vivaaerobus.com/Upload-VB/vb-logo.png">
                    </div>
                    <div class="logo">
                        <img src="http://content.vivaaerobus.com/cdn/img/laboratio-aries-logo.jpeg">
                    </div>
                </div>
                <div class="spacer quarter"></div>
                <h3 class="txt-center">Validación de reserva</h3>
                <div class="spacer quarter"></div>

                <div class="error-badge" v-if="showError">
                    <div class="icon">
                        <img src="https://content.vivaaerobus.com/cdn/vouchers/warning_ico.png">
                    </div>
                    <div class="text">
                        <p>{{ errorMessage }}</p>
                    </div>
                </div>                

                <div class="inputs">
                    <div class="input">
                        <label for="reservationCode">Clave de reservación</label>
                        <input type="text" placeholder="6 caracteres" class="viva-input" maxlength="6" v-model="pnr"
                            name="reservationCode" autocomplete="off">
                    </div>
                    <div class="input">
                        <label for="password">Contraseña de acceso</label>
                        <input type="password" placeholder="Contraseña" class="viva-input" maxlength="100"
                            v-model="password" name="password" autocomplete="off">
                    </div>
                </div>
                <br>
                <div class="buttons">
                    <button class="viva-btn" :disabled="pnr === '' || password === '' || pnr.length < 6"
                        :class="{'loading': loadingButton}" @click="validatePNR">Entrar<span
                            class="vb-loader">X</span></button>
                </div>

            </div>
        </transition>
        <transition>
            <div class="step-2" v-if="currentStep === 2" ref="step2">
                <h3>Detalles de la reservación </h3>
                <p>A continuación, se presenta la información actualizada del itinerario ligado a la reserva ingresada.
                </p>

                <template v-for="(rd, index) of reserveDetail">
                    <div :key="index">
                        <div class="flight-pnr-info">
                            <p><strong>{{ (rd.MostrarItinerario && rd.Valido)?rd.nombres:nameMask(rd.nombres) }}
                                    {{ (rd.MostrarItinerario && rd.Valido)?rd.apellidos:nameMask(rd.apellidos) }}</strong><br>{{ (rd.MostrarItinerario && rd.Valido)?rd.correo:"" }}<br
                                    v-if="rd.MostrarItinerario && rd.Valido">{{ (rd.MostrarItinerario && rd.Valido)?rd.telefono:"" }}
                            </p>
                            <h4 class="uppercase">{{ pnr }}</h4>
                        </div>

                        <template v-for="(vd, indexvd) of rd.VuelosDetalle">
                            <template>
                                <div class="flight-detail" :key="indexvd"
                                    v-if="(vd.TipoVuelo !== 'Directo')?(indexvd === 0 || indexvd + 1 === rd.VuelosDetalle.length)?true:false:true">
                                    <div class="left">
                                        <p><strong>{{ humanDestination[vd.Origen] }} -
                                                {{ humanDestination[vd.Destino] }}</strong></p>
                                        <p><span v-if="vd.TipoVuelo !== 'Directo'" class="connection"><small>(Vuelo con
                                                    conexión)</small></span></p>
                                        <p>{{ formatDate(vd.STD) }}</p>
                                    </div>
                                    <div class="right">
                                        <p><strong>{{ vd.Origen }} - {{ vd.Destino }}</strong></p>
                                    </div>
                                </div>
                            </template>
                        </template>

                        <p>{{ rd.NumeroPasajeros }}
                            Pasajero{{ (rd.NumeroPasajeros > 1)?"s":"" }}</p>

                        <br>
                        <div class="buttons">
                            <button class="viva-btn" :disabled="pnr === '' || password === '' || pnr.length < 6"
                                :class="{'loading': loadingButton}" @click="setStep(1)">Nueva Búsqueda<span
                                    class="vb-loader">X</span></button>
                        </div>

                    </div>
                </template>

                <br>
            </div>
        </transition>
    </div>
</template>

<script>
import axios from 'axios';
import {
    format
} from 'date-fns';
import {
    es,
} from 'date-fns/locale'
import currency from 'currency.js';

export default {
    data() {
        return {
            pnr: "",
            password: "",
            currentStep: 1,
            totalSteps: 3,
            globalStyles: {},
            showError: false,
            errorMessage: "",
            loadingButton: false,
            reserveDetail: null,
            currency: "MXN",
            humanDestination: {
                "ACA": "Acapulco",
                "CUN": "Cancún",
                "CTM": "Chetumal",
                "CUU": "Chihuahua",
                "MEX": "Ciudad de México",
                "CJS": "Ciudad Juárez",
                "CEN": "Ciudad Obregón",
                "CUL": "Culiacán",
                "GDL": "Guadalajara",
                "HMO": "Hermosillo",
                "HUX": "Huatulco",
                "ZIH": "Ixtapa Zihuatanejo",
                "LAP": "La Paz",
                "BJX": "León",
                "SJD": "Los Cabos",
                "MZT": "Mazatlán",
                "MID": "Mérida",
                "MXL": "Mexicali",
                "MTY": "Monterrey",
                "OAX": "Oaxaca",
                "PBC": "Puebla",
                "PXM": "Puerto Escondido",
                "PVR": "Puerto Vallarta",
                "QRO": "Querétaro",
                "REX": "Reynosa",
                "TAM": "Tampico",
                "TIJ": "Tijuana",
                "TRC": "Torreón",
                "TGZ": "Tuxtla Gutiérrez",
                "VER": "Veracruz",
                "VSA": "Villahermosa",
                "IAH": "Houston",
                "LAS": "Las Vegas",
                "LAX": "Los Ángeles",
                "SJO": "San José",
                "DGO": "Durango",
                "MLM": "Morelia",
                "JFK": "New York",
                "EWR": "New York (Newark)",
                "TLC": "Toluca"
            },
            humanDestinationEN: {
                "ACA": "Acapulco",
                "CUN": "Cancun",
                "CTM": "Chetumal",
                "CUU": "Chihuahua",
                "MEX": "Mexico City",
                "CJS": "Juarez City",
                "CEN": "Obregon City",
                "CUL": "Culiacan",
                "GDL": "Guadalajara",
                "HMO": "Hermosillo",
                "HUX": "Huatulco",
                "ZIH": "Ixtapa Zihuatanejo",
                "LAP": "La Paz",
                "BJX": "Leon",
                "SJD": "Los Cabos",
                "MZT": "Mazatlan",
                "MID": "Merida",
                "MXL": "Mexicali",
                "MTY": "Monterrey",
                "OAX": "Oaxaca",
                "PBC": "Puebla",
                "PXM": "Puerto Escondido",
                "PVR": "Puerto Vallarta",
                "QRO": "Queretaro",
                "REX": "Reynosa",
                "TAM": "Tampico",
                "TIJ": "Tijuana",
                "TRC": "Torreon",
                "TGZ": "Tuxtla Gutierrez",
                "VER": "Veracruz",
                "VSA": "Villahermosa",
                "IAH": "Houston",
                "LAS": "Las Vegas",
                "LAX": "Los Angeles",
                "SJO": "San Jose",
                "DGO": "Durango",
                "MLM": "Morelia",
                "JFK": "New York",
                "EWR": "New York (Newark)",
                "TLC": "Toluca"
            }
        }
    },
    methods: {
        setStep(stepNumber = 1) {
            this.currentStep = stepNumber;
            this.showError = false;
            this.globalContainerHeight();
        },
        globalContainerHeight() {
            setTimeout(() => {
                let output = {};
                switch (this.currentStep) {
                    case 1:
                        output.height = this.$refs.step1.clientHeight + 'px';
                        break;
                    case 2:
                        output.height = this.$refs.step2.clientHeight + 'px';
                        break;
                }
                this.globalStyles = output;
            }, 100);
        },
        formatDate(stringDate = "") {
            if (stringDate !== "") {
                let rule = /(.+)-(.+)-(.+)\ ([0-9]+:[0-9]+):[0-9]+\ ([AM|PM]+)/
                stringDate = stringDate.replace(/\//gi, "-");
                let newDate = stringDate.match(rule);
                var formatedDate = format(new Date(newDate[3], newDate[1] - 1, newDate[2]), "d 'de' MMMM 'de' yyyy", {
                    locale: es
                });
                formatedDate += `, ${newDate[4]} ${newDate[5]}`;
                return formatedDate;
            }
            return "";
        },
        validatePNR() {
            this.loadingButton = true;
            let url = "https://fqr97a9mdg.execute-api.us-east-1.amazonaws.com/prod/GateWayAppsVivaAerobus/ssrprotect/validapnr";
            let data = {
                PNR: this.pnr,
                Clave: this.password,
            };

            axios({
                method: 'post',
                url,
                data
            }).then((d) => {
                console.log(d.data.body);
                let user1 = d.data.body.data[0];
                this.loadingButton = false;
                // if (!user1.Valido && !user1.MostrarItinerario) {
                //     this.errorMessage = user1.MessageResponse;
                //     this.showError = true;
                // } else if (!user1.Valido || !user1.MostrarItinerario) {
                //     this.errorMessage = user1.MessageResponse;
                //     this.showError = true;
                // } else if (user1.Valido && user1.MostrarItinerario) {
                //     //next step
                //     this.reserveDetail = d.data.body.data;
                //     this.setStep(2);
                // }
                console.log('booking status', user1.BookingStatus);
                if (user1.BookingStatus === "Confirmed") {
                    //continue
                    this.reserveDetail = d.data.body.data;
                    this.setStep(2);
                } else if (user1.BookingStatus === null) {
                    this.errorMessage = 'Esta reservación no existe';
                    this.showError = true;
                } else if (user1.BookingStatus !== "Confirmed" && user1.BookingStatus !== null) {
                    this.errorMessage = 'Esta reservación no está confirmada';
                    this.showError = true;
                }

            }).catch((e) => {
                console.warn(e);
                this.loadingButton = false;
            });
        },
        emailMask(email) {
            if (email !== null && email !== "") {
                var maskedEmail = email.replace(/([^@\.])/g, "*").split('');
                var previous = "";
                for (let i = 0; i < maskedEmail.length; i++) {
                    if (i <= 1 || previous == "." || previous == "@") {
                        maskedEmail[i] = email[i];
                    }
                    previous = email[i];
                }
                return maskedEmail.join('');
            } else {
                console.log(email);
                return "";
            }

        },
        nameMask(name) {
            // let newString = "";
            // for (let x = 0; x < name.length; x++) {
            //     newString += (x > 0) ? "*" : name.charAt(x);
            // }
            // return newString;
            return name;
        },
        formatMoney(amount) {
            return currency(amount, {
                formatWithSymbol: true
            }).format();
        }
    },
    computed: {

    },
    mounted() {
        this.setStep(1);
        let uri = window.location.href.split('?');

        if (uri.length == 2) {
            let vars = uri[1].split('&');
            let getVars = {};
            let tmp = '';
            vars.forEach(function (v) {
                tmp = v.split('=');
                if (tmp.length == 2)
                    getVars[tmp[0]] = tmp[1];
            });
            if (typeof getVars.pnr !== 'undefined') {
                this.pnr = getVars.pnr;
            }
            if (typeof getVars.password !== 'undefined') {
                this.password = getVars.password.replace(/%20/gi, ' ');
            }
        }

    },
}
</script>
